import React, { useState } from 'react';
import axios from 'axios';
import { Formik, Field, Form, ErrorMessage } from "formik";
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import ConfirmationModal from '../shared/ConfirmationModal';
import NewconfirmationModal from '../shared/NewconfirmationModal';
import AllFailureModal from '../shared/AllFailureModal';

const FAQAdd = () => {
    const navigate = useNavigate();
    const [modalShow, setModalShow] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [status, setStatus] = useState(false);
    const [pendingAction, setPendingAction] = useState<(() => void) | null>(null);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [showFailureModal, setShowFailureModal] = useState(false);
    const [failureMessage, setFailureMessage] = useState("");

    const callApiFAQAdd = async (values: any, resetForm: any) => {
        setModalMessage("Are you sure you want to add this FAQ?");
        setPendingAction(() => async () => {
            try {
                const url = process.env.REACT_APP_API_URL + 'faqs/add';
                const response = await axios.post(url, values, { headers: { "Content-Type": "application/json" } });
                if (response.status === 201) {
                    setSuccessMessage("FAQ added successfully.");
                    setStatus(true);
                    setShowSuccessModal(true);
                    resetForm();
                    setTimeout(() => navigate('/FAQPage'), 8000);
                }
            } catch (error: any) {
                setFailureMessage(error.response?.data?.message || "Failed to add FAQ.");
                setShowFailureModal(true);
            }
        });
        setModalShow(true);
    }

    const handleModalOk = () => {
        setModalShow(false);
        if (pendingAction) pendingAction();
    }

    return (
        <Container className="mt-5">
            <Row className="justify-content-center">
                <Col md={8}>
                    <Card className="shadow">
                        <Card.Header className="bg-info text-white text-center">
                            <h4>Add FAQ</h4>
                        </Card.Header>
                        <Card.Body>
                            <Formik
                                initialValues={{ question: "", answer: "", type: "" }}
                                onSubmit={async (values, { resetForm }) => {
                                    await callApiFAQAdd(values, resetForm);
                                }}
                            >
                                {({ values }) => (
                                    <Form>
                                        <Row className="mb-3">
                                            <Col md={12}>
                                                <label htmlFor="question" className="form-label">Question:</label>
                                                <Field name="question" type="text" className="form-control" placeholder="Enter question" required />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md={12}>
                                                <label htmlFor="answer" className="form-label">Answer:</label>
                                                <Field name="answer" as="textarea" className="form-control" placeholder="Enter answer" required />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md={12}>
                                                <label htmlFor="type" className="form-label">Type:</label>
                                                <Field name="type" as="select" className="form-control" required>
                                                    <option value="">Select Type</option>
                                                    <option value="Employer">Employer</option>
                                                    <option value="Candidate">Candidate</option>
                                                    <option value="Admin">Admin</option>
                                                </Field>
                                            </Col>
                                        </Row>
                                        <Row className="mt-4">
                                            <Col className="text-center">
                                                <Button type="submit" variant="success">Add FAQ</Button>
                                                <Button variant="danger" className="mx-2" onClick={() => navigate("/FAQPage")}>Go Back</Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                )}
                            </Formik>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <ConfirmationModal show={modalShow} modalMessage={modalMessage} onHide={() => setModalShow(false)} confirmation={handleModalOk} operationType="Confirm" />

            <NewconfirmationModal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} modalMessage={successMessage} operationType="Ok" timeoutduration={3000} />
            <AllFailureModal show={showFailureModal} onHide={() => setShowFailureModal(false)} modalMessage={failureMessage} operationType="Ok" timeoutduration={5000} />
        </Container>
    )
}

export default FAQAdd;
